__webpack_require__.O(0, ["data_list"], () => {
	__webpack_require__.E("resources_src_js_share_components__common_lazy_js");
	__webpack_require__.E("resources_src_js_share_components__font_family_js");
}, 5);